import { createStructuredSelector } from 'reselect';
import {
  ACQUISITION_DETAIL_BIDDABLE_LIST,
  ACQUISITION_DETAIL_BIDDABLE_LIST_SUCCESS,
  ACQUISITION_DETAIL_BIDDABLE_LIST_ERROR,
  ACQUISITION_DETAIL_BIDDABLE_PAGE_SET,
  ACQUISITION_DETAIL_BIDDABLE_ADD,
  ACQUISITION_DETAIL_BIDDABLE_ADD_SUCCESS,
  ACQUISITION_DETAIL_BIDDABLE_ADD_ERROR,
  ACQUISITION_DETAIL_BIDDABLE_ADD_CHANGE,
  ACQUISITION_DETAIL_BIDDABLE_UPDATE,
  ACQUISITION_DETAIL_BIDDABLE_UPDATE_SUCCESS,
  ACQUISITION_DETAIL_BIDDABLE_UPDATE_ERROR,
} from '../../actions';

export const NAME = 'acquisition_detail';

export const AcquisitionDetailBiddableList = (payload) => ({ type: ACQUISITION_DETAIL_BIDDABLE_LIST, payload });
export const AcquisitionDetailBiddableListSuccess = (data) => ({ type: ACQUISITION_DETAIL_BIDDABLE_LIST_SUCCESS, payload: data });
export const AcquisitionDetailBiddableListError = (error) => ({ type: ACQUISITION_DETAIL_BIDDABLE_LIST_ERROR, payload: error });
export const AcquisitionDetailBiddablePageSet = (data) => ({ type: ACQUISITION_DETAIL_BIDDABLE_PAGE_SET, payload: data });
export const AcquisitionDetailBiddableAddChangeSet = (data) => ({ type: ACQUISITION_DETAIL_BIDDABLE_ADD_CHANGE, payload: data });
export const AcquisitionDetailBiddableAdd = (data) => ({ type: ACQUISITION_DETAIL_BIDDABLE_ADD, payload: data });
export const AcquisitionDetailBiddableAddSuccess = (message) => ({ type: ACQUISITION_DETAIL_BIDDABLE_ADD_SUCCESS, payload: message });
export const AcquisitionDetailBiddableAddError = (error) => ({ type: ACQUISITION_DETAIL_BIDDABLE_ADD_ERROR, payload: error });
export const AcquisitionDetailBiddableUpdate = (data) => ({ type: ACQUISITION_DETAIL_BIDDABLE_UPDATE, payload: data });
export const AcquisitionDetailBiddableUpdateSuccess = (message) => ({ type: ACQUISITION_DETAIL_BIDDABLE_UPDATE_SUCCESS, payload: message.message });
export const AcquisitionDetailBiddableUpdateError = (error) => ({ type: ACQUISITION_DETAIL_BIDDABLE_UPDATE_ERROR, payload: error });

const acquisition_detail = (state) => state[NAME];
export const AcquisitionDetailSelector = createStructuredSelector({ acquisition_detail });
